let MAPTHUMBNAIL_UPLOADPATH_ANDROID = "androidThumbnail";
let MAPTHUMBNAIL_UPLOADPATH_WINDOWS = "windowThumbnail";

export {MAPTHUMBNAIL_UPLOADPATH_ANDROID, MAPTHUMBNAIL_UPLOADPATH_WINDOWS};